module.exports = __webpack_public_path__ + "img/12_62.a766a838.png";